import { PreviewImageDetail } from "./preview-image-detail";

export class TableData {
  id: string;
  inspectionId: string;
  identifiers: string[];
  names: string[];
  inspectionFor: string[];
  mark: number;
  title: string;
  comment: string;
  images: ImageComponent[];
  columnSpan: number[];
  _value: string;
  measurementItems: any[];
  previewImage?: PreviewImageDetail;

  constructor() {
    this.id = '';
    this.inspectionId = '';
    this.mark = 0;
    this.title = '';
    this.comment = '';
    this.identifiers = [];
    this.names = [];
    this.inspectionFor = [];
    this.images = [];
    this.columnSpan = [];
    this.measurementItems = [];
  }

  getClone() {
    const clone = new TableData();

    clone.id = this.id;
    clone.inspectionId = this.inspectionId;
    clone.mark = this.mark;
    clone.title = this.title;
    clone.comment = this.comment;

    clone.identifiers = JSON.parse(JSON.stringify(this.identifiers));
    clone.images = JSON.parse(JSON.stringify(this.images));
    clone.inspectionFor = JSON.parse(JSON.stringify(this.inspectionFor));
    clone.names = JSON.parse(JSON.stringify(this.names));
    clone.columnSpan = JSON.parse(JSON.stringify(this.columnSpan));
    clone.measurementItems = JSON.parse(JSON.stringify(this.measurementItems));
    clone.previewImage = this.previewImage ? JSON.parse(JSON.stringify(this.previewImage)) : undefined;

    return clone;
  }
}

export namespace ImageAreaType {
  export const Static = 'static';
  export const Dynamic = 'dynamic';
}

export class ReportComponentBase {
  public x: number;
  public y: number;
  public width: number;
  public height: number;
  public maxWidth: number;
  public maxHeight: number;

  getSizeStyle(sizeUnit: string, maxWidth = 0, maxHeight = 0, orientation = 1) {
    const style = {};

    if (this.width !== 0) {
      style[`width.${sizeUnit}`] = this.width;
    } else {
      style[`width`] = 'auto';
    }

    if (this.height !== 0) {
      style[`height.${sizeUnit}`] = this.height;
    } else {
      style[`height`] = 'auto';
    }

    if (maxWidth !== 0) {
      style[`max-width.${sizeUnit}`] = maxWidth;
    } else {
      style[`max-width`] = 'initial';
    }

    if (maxHeight !== 0) {
      style[`max-height.${sizeUnit}`] = maxHeight;
    } else {
      style[`max-height`] = 'initial';
    }

    if (this.height < maxHeight) {
      const h = maxHeight - this.height;

      style[`margin-top.${sizeUnit}`] = h / 2;
      style[`margin-bottom.${sizeUnit}`] = h / 2;
    }

    if (this.width < maxWidth) {
      const w = maxWidth - this.width;

      style[`margin-right.${sizeUnit}`] = w / 2;
      style[`margin-left.${sizeUnit}`] = w / 2;
    }

    return style;
  }

  getPositionStyle(sizeUnit: string, isAbsolute: boolean = true) {
    const style = {};

    if (isAbsolute) {
      style['position'] = 'absolute';
    }

    style['left'] = `${this.x + sizeUnit}`;
    style['top'] = `${this.y + sizeUnit}`;

    return style;
  }

  getVerticalTextSizeStyle(sizeUnit: string, maxWidth = 0, maxHeight = 0) {
    const style = {};

    if (this.width !== 0) {
      style[`width.${sizeUnit}`] = this.width;
    } else {
      style[`width`] = 'auto';
    }

    if (this.height !== 0) {
      style[`height.${sizeUnit}`] = this.height;
    } else {
      style[`height`] = 'auto';
    }

    if (maxWidth !== 0) {
      style[`max-width.${sizeUnit}`] = maxWidth;
    } else {
      style[`max-width`] = 'initial';
    }

    if (maxHeight !== 0) {
      style[`max-height.${sizeUnit}`] = maxHeight;
    } else {
      style[`max-height`] = 'initial';
    }

    if (this.width < maxHeight) {
      const w = maxHeight - this.width;

      style[`margin-right.${sizeUnit}`] = w / 2;
      style[`margin-left.${sizeUnit}`] = w / 2;
    }

    if (this.height < maxWidth) {
      const h = maxWidth - this.height;

      style[`margin-top.${sizeUnit}`] = h / 2;
      style[`margin-bottom.${sizeUnit}`] = h / 2;
    }

    return style;
  }

  getTextAreaTableStyle(isHorizontal: boolean, sizeUnit: string) {
    let style = {};
    if (isHorizontal) {
      style = this.getSizeStyle(sizeUnit);
    } else {
      style = this.getVerticalTextSizeStyle(sizeUnit);
    }
    style['display'] = 'table';

    return style;
  }
}

export class ImageComponent extends ReportComponentBase {
  public id: string;
  public caption: string;
  public src: string;
  public type: string;
  public orientation: number;

  public isAbsolute: boolean;
  public isDummy: boolean;
  public width: number;
  public height: number;
  public maxWidth: number;
  public maxHeight: number;

  public modifiedWidth: number;
  public modifiedHeight: number;
  public usedImageMode: number;

  constructor(id: string, src: string, width: number, height: number, isDummy: boolean, orientation: number, usedImagedMode?: number, modifiedWidth?: number, modifiedHeight?: number) {
    super();
    this.id = id;
    this.src = src;
    this.type = ImageAreaType.Static;
    this.setSize(width, height, orientation);
    this.isDummy = isDummy;
    this.usedImageMode = usedImagedMode ? usedImagedMode : 0;
    this.modifiedWidth = modifiedWidth ? modifiedWidth : null;
    this.modifiedHeight = modifiedHeight ? modifiedHeight : null;
  }

  setSize(width: number, height: number, orientation: number) {
    this.width = width;
    this.height = height;
    this.orientation = orientation ?? 0;
  }
}
